module.exports = __webpack_public_path__ + "static/media/HomeStoryLogo8.3a115ae8.png";